// extracted by mini-css-extract-plugin
module.exports = {"link":"TextLinkControl_link__x9rPu","icon":"TextLinkControl_icon__QwQJw","text":"TextLinkControl_text__9M8a6"};